<template>
  <div>
    <!-- 全局右侧悬浮组件（全局复用） -->
    <!-- <SideFloat /> -->

    <!-- 1. 轮播图区域 -->
    <section class="relative h-[400px] md:h-[600px] overflow-hidden">
      <!-- Swiper 容器 -->
      <Swiper v-if="isSwiper" :modules="[Navigation, Pagination, Autoplay]" :space-between="0" :slides-per-view="1"
        :autoplay="{ delay: 3000, disableOnInteraction: false }" :loop="true" :pagination="{ clickable: true }"
        :navigation="true" class="h-full">
        <!-- 轮播图1 -->
        <SwiperSlide class="h-full" v-for="(item,index) in bannerList" :key="index">
          <div class="h-full relative">
            <!-- 配图：MLV产品特写（突出材质质感与工艺精度） -->
            <img :src="item.photoOssUrl" alt="High-quality MLV Products - Close-up of Material Texture"
              class="w-full h-full object-cover">
            <div class="absolute inset-0 bg-black bg-opacity-30 flex items-center">
              <div class="container mx-auto px-6">
                <h2 class="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">{{ item.name }}</h2>
                <p class="text-base md:text-xl text-white mb-6 max-w-2xl">{{ item.subName }}</p>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>

    <!-- 2. 产品简介区域（6个产品） -->
    <section class="py-16 bg-gray-50">
      <div class="container mx-auto px-6">
        <div class="text-center mb-12">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Premium Products</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">"Jinyaque" Damping Mats: 25-40dB Noise Reduction for Residential/Commercial/Industrial Spaces</p>
        </div>

        <!-- 产品列表 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- 产品1: Wax Ribbon -->
           
          <div
            class="product-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow group" v-for="item in productList" :key="item.id">
            <router-link :to="{ name: 'ProductDetail', params: { productId: item.id } }">
            <div class="relative overflow-hidden h-60">
              <img :src="item.imagesUrl[0]" alt="N011 Wax Premium Thermal Transfer Ribbon"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110">
              <div class="absolute inset-0 bg-primary bg-opacity-0 group-hover:bg-opacity-10 transition-all"></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-semibold text-gray-800 mb-2">{{ item.name}}</h3>
              <!-- <p class="text-gray-600 mb-4">High-speed wax ribbon for paper & synthetic labels, ideal for retail
                packaging</p> -->
              <div class="flex justify-between items-center">
                <span class="text-primary font-bold"></span>
                <router-link :to="{ name: 'ProductDetail', params: { productId: item.id } }"
                  class="inline-flex items-center text-primary font-medium hover:text-primary/80">
                  Details <i class="fa fa-arrow-right ml-2 text-sm"></i>
                </router-link>
              </div>
            </div>
             </router-link>
          </div>
        </div>
        <!-- 查看全部产品按钮 -->
        <div class="text-center tex mt-12">
          <router-link to="/products"
            class="inline-block border-2 border-primary text-primary px-8 py-3 bg-white rounded-md hover:bg-black hover:text-white transition-colors">
            View All Products <i class="fa fa-long-arrow-right ml-2"></i>
          </router-link>
          <!-- <router-link 
            to="/products" 
            class="inline-block bg-primary text-white px-8 py-3 rounded-md hover:bg-primary/90 transition-colors"
          >
            View All Products <i class="fa fa-long-arrow-right ml-2"></i>
          </router-link> -->
        </div>
      </div>
    </section>

    <!-- 3. 生产工艺简介 -->
    <section class="py-16">
      <div class="container mx-auto px-6">
        <div class="flex flex-col lg:flex-row items-center gap-12">
          <div class="lg:w-1/2">
            <img src="@/assets/images/technology.jpg" alt="Advanced Damping Soundproof Mat Production Line"
              class="w-full rounded-lg shadow-lg">
          </div>
          <div class="lg:w-1/2">
            <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-6">Advanced Manufacturing & Product Advantages
            </h2>
            <p class="text-gray-600 mb-4">
              Zhengzhou SoundProof New Materials Technology Co., Ltd. is a leading manufacturer of damping soundproof
              mats under the registered brand "Jinyaque". Adhering to the core philosophy of "Technology Reduces Noise,
              Builds Boundless Beauty", we specialize in R&D, production and global supply of high-performance acoustic
              solutions.
            </p>
            <ul class="space-y-3 mb-6">
              <li class="flex items-start">
                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                <span>Green production process: High-temperature calendering & physical compounding, zero waste
                  discharge</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                <span>Superior sound insulation: 20-30dB noise reduction, 90% iron powder content for optimal surface
                  density</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                <span>Multi-certified quality: SGS environmental certification, GB/T20219-2006 standard, UL94-V0 & B1
                  fire rating</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                <span>Exceptional durability: -30℃~80℃ temperature resistance, 60-year service life, waterproof &
                  moisture-proof</span>
              </li>
              <li class="flex items-start">
                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                <span>Environmentally friendly: No harmful additives, heavy metal content far below international limits
                  (Pb＜100mg/kg)</span>
              </li>
            </ul>
            <router-link to="/about"
              class="inline-block bg-primary text-white px-6 py-3 rounded-md hover:bg-primary/90 transition-colors">
              Explore Our Technology <i class="fa fa-arrow-right ml-2"></i>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 4. 应用场景 -->
    <section class="py-16 bg-gray-50">
      <div class="container mx-auto px-6">
        <div class="text-center mb-12">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Application Scenarios</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">
            Full-Scenario Noise Control: KTVs, Hotels, Hospitals, Industrial Rooms & More
          </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-8">
          <!-- 资质1 -->
          <div class="bg-white p-3 rounded-lg shadow-md flex flex-col items-center" v-for="item in applicationList"
            :key="item.id">
            <div class="w-full h-28 mb-4 overflow-hidden rounded">
              <img :src="item.photoOssUrl" alt="ISO 9001 Certification"
                class="w-full h-full object-cover transition-transform hover:scale-105 duration-300">
            </div>
            <h3 class="text-lg font-semibold text-gray-800">{{ item.name }}</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 5. 最新新闻动态（6条） -->
    <!-- <section class="py-16">
      <div class="container mx-auto px-6">
        <div class="text-center mb-12">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Latest Industry News</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">Insights, trends & updates from the thermal transfer printing industry</p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/40/600/300" 
                alt="How Printhead Temperature Affects Ribbon Performance" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-primary text-white text-xs px-3 py-1 rounded-full">
                Technical Guide
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Oct 15, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">How Printhead Temperature Affects Ribbon Performance</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Learn how to optimize printhead temperature for different ribbon types—avoid smudging and extend printhead life.</p>
              <router-link 
                to="/news/1" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/41/600/300" 
                alt="Eco-Friendly Thermal Transfer Materials: What’s Next" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-green-600 text-white text-xs px-3 py-1 rounded-full">
                Sustainability
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Sep 28, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">Eco-Friendly Thermal Transfer Materials</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Our new biodegradable resin ribbons—meet environmental goals without compromising performance.</p>
              <router-link 
                to="/news/2" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/42/600/300" 
                alt="The Ultimate Guide to Ribbon Cost & Efficiency" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-blue-600 text-white text-xs px-3 py-1 rounded-full">
                Business Tips
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Sep 10, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">Ribbon Cost & Efficiency Guide</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Calculate total cost of ownership (TCO) for thermal ribbons—how to balance quality and budget.</p>
              <router-link 
                to="/news/3" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/43/600/300" 
                alt="New TTO Ribbon for Food Packaging Applications" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-purple-600 text-white text-xs px-3 py-1 rounded-full">
                New Product
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Aug 25, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">New TTO Ribbon for Food Packaging</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Our new N682 TTO ribbon meets FDA standards for direct food contact—ideal for meat & dairy packaging.</p>
              <router-link 
                to="/news/4" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/44/600/300" 
                alt="OnlyImaging Exhibits at Pack Expo 2025" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-orange-600 text-white text-xs px-3 py-1 rounded-full">
                Events
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Aug 5, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">OnlyImaging at Pack Expo 2025</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Visit our booth #C123 at Pack Expo Las Vegas—see live demos of our latest thermal ribbon technology.</p>
              <router-link 
                to="/news/5" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
          <div class="news-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
            <div class="relative h-48">
              <img 
                src="https://picsum.photos/id/45/600/300" 
                alt="How to Extend Thermal Ribbon Shelf Life" 
                class="w-full h-full object-cover"
              >
              <div class="absolute top-4 left-4 bg-gray-600 text-white text-xs px-3 py-1 rounded-full">
                Maintenance
              </div>
            </div>
            <div class="p-6">
              <p class="text-gray-500 text-sm mb-2">Jul 18, 2025</p>
              <h3 class="text-xl font-semibold text-gray-800 mb-3">Extend Thermal Ribbon Shelf Life</h3>
              <p class="text-gray-600 mb-4 line-clamp-2">Storage best practices to keep ribbons in optimal condition—temperature, humidity & packaging tips.</p>
              <router-link 
                to="/news/6" 
                class="inline-flex items-center text-primary font-medium hover:text-primary/80"
              >
                Read More <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="text-center mt-12">
          <router-link 
            to="/news" 
            class="inline-block border-2 border-primary text-primary px-8 py-3 rounded-md hover:bg-primary hover:text-white transition-colors"
          >
            View All News <i class="fa fa-long-arrow-right ml-2"></i>
          </router-link>
        </div>
      </div>
    </section> -->

    <!-- 6. 客户咨询区域 -->
    <!-- <section class="py-16 bg-primary bg-opacity-5">
      <div class="container mx-auto px-6">
        <div class="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
          <div class="text-center mb-8">
            <h2 class="text-3xl font-bold text-gray-800 mb-4">Need a Custom Solution?</h2>
            <p class="text-gray-600">Tell us your requirements—our team will respond within 24 hours</p>
          </div>

          <form class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label for="name" class="block text-gray-700 mb-2 text-sm">Full Name</label>
              <input 
                type="text" 
                id="name" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="John Doe"
                required
              >
            </div>
            <div>
              <label for="company" class="block text-gray-700 mb-2 text-sm">Company Name</label>
              <input 
                type="text" 
                id="company" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="ABC Packaging Co."
                required
              >
            </div>
            <div>
              <label for="email" class="block text-gray-700 mb-2 text-sm">Email Address</label>
              <input 
                type="email" 
                id="email" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="john@example.com"
                required
              >
            </div>
            <div>
              <label for="phone" class="block text-gray-700 mb-2 text-sm">Phone Number</label>
              <input 
                type="tel" 
                id="phone" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="+1-800-123-4567"
                required
              >
            </div>
            <div class="md:col-span-2">
              <label for="product" class="block text-gray-700 mb-2 text-sm">Product Interest</label>
              <select 
                id="product" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                required
              >
                <option value="">Select a product category</option>
                <option value="wax">Wax Ribbons</option>
                <option value="resin">Resin Ribbons</option>
                <option value="wax-resin">Wax/Resin Ribbons</option>
                <option value="tto">TTO Ribbons</option>
                <option value="wash-care">Wash Care Ribbons</option>
                <option value="hot-foil">Hot Stamping Foils</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <label for="message" class="block text-gray-700 mb-2 text-sm">Your Message</label>
              <textarea 
                id="message" 
                rows="4" 
                class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Please describe your application, required specifications, or question..."
                required
              ></textarea>
            </div>
            <div class="md:col-span-2 text-center">
              <button 
                type="submit" 
                class="w-full md:w-auto bg-primary text-white px-8 py-3 rounded-md hover:bg-primary/90 transition-colors"
              >
                Send Inquiry <i class="fa fa-paper-plane ml-2"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { listSlider, listIndexApplication,listIndexProduct } from '@/api/index'
// 1. 引入 Swiper 核心及所需模块
import { Swiper, SwiperSlide } from 'swiper/vue'
// 引入 Swiper 样式（基础样式 + 导航/指示器样式）
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
// 引入需要的功能模块（导航、分页、自动轮播）
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
const isSwiper = ref(false)
// 轮播图逻辑
// const currentSlide = ref(0)
// const totalSlides = 3 // 轮播图数量

// // 下一张轮播图
// const nextSlide = () => {
//   currentSlide.value = (currentSlide.value + 1) % totalSlides
// }

// // 上一张轮播图
// const prevSlide = () => {
//   currentSlide.value = (currentSlide.value - 1 + totalSlides) % totalSlides
// }

// 自动轮播
// let slideInterval = null
onMounted(() => {
  getBannerList()
  getListIndexApplication()
  getListIndexProduct()
  // 3秒自动切换一次
  // slideInterval = setInterval(nextSlide, 3000)
})
const applicationList = ref([])
const productList = ref([])
const bannerList = ref([])
const getBannerList = async () => {
  isSwiper.value = false
  let res = await listSlider()
  bannerList.value = res.data
  isSwiper.value = true
  console.log(res.data,'banner')
}
const getListIndexApplication = async () => {
  let res = await listIndexApplication()
  applicationList.value = res.data
}
const getListIndexProduct = async () => {
  let res = await listIndexProduct()
  productList.value = res.data
  console.log(res.data)
}
// 清除自动轮播（组件卸载时）
onUnmounted(() => {
  // clearInterval(slideInterval)
})
</script>

<style scoped>
/* 1. 自定义 Swiper 指示器（小圆点）样式 */
:deep(.swiper-pagination-bullet) {
  width: 12px;
  /* 小圆点宽度 */
  height: 12px;
  /* 小圆点高度 */
  background: rgba(255, 255, 255, 0.7);
  /* 未激活状态颜色 */
  opacity: 1;
  margin: 0 6px !important;
  /* 圆点间距 */
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* 激活的指示器样式 */
:deep(.swiper-pagination-bullet-active) {
  width: 24px;
  /* 激活时变宽（如原设计的长条效果） */
  border-radius: 6px;
  /* 激活时变椭圆 */
  background: #ffffff;
  /* 激活状态颜色（白色） */
}

/* 2. 自定义 Swiper 导航箭头样式 */
:deep(.swiper-button-prev),
:deep(.swiper-button-next) {

  width: 40px;
  /* 箭头按钮宽度 */
  height: 40px;
  /* 箭头按钮高度 */
  background: rgba(255, 255, 255, 0.7);
  /* 按钮背景 */
  border-radius: 50%;
  /* 圆形按钮 */
  color: #333333;
  /* 箭头颜色 */
  transition: all 0.3s ease;
}

:deep(.swiper-button-prev) {
  left: 30px;
}

:deep(.swiper-button-next) {
  right: 30px;
}

/* 箭头图标大小调整 */
:deep(.swiper-button-prev svg),
:deep(.swiper-button-next svg) {
  width: 10px !important;
  height: 18px !important;
}

/* 鼠标悬浮时按钮样式 */
:deep(.swiper-button-prev:hover),
:deep(.swiper-button-next:hover) {
  background: #ffffff;
  /* 悬浮时背景变纯黑 */
  color: #000000;
  /* 悬浮时箭头变黑色 */
}

/* 3. 响应式适配：移动端优化箭头和指示器 */
@media (max-width: 767px) {

  /* 移动端箭头缩小 */
  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    width: 32px;
    height: 32px;
    display: none;
  }

  :deep(.swiper-button-prev svg),
  :deep(.swiper-button-next svg) {
    width: 8px !important;
    height: 16px !important;
  }

  /* 移动端指示器间距缩小 */
  :deep(.swiper-pagination-bullet) {
    width: 8px;
    height: 8px;
    margin: 0 4px !important;
  }

  :deep(.swiper-pagination-bullet-active) {
    width: 16px;
  }
}

/* 轮播图基础样式 */
.carousel-item {
  z-index: 1;
}

.carousel-item.opacity-100 {
  z-index: 2;
}

/* 产品卡片hover效果优化 */
.product-card:hover .text-primary {
  color: #124ED1;
  /* 加深主色，增强hover反馈 */
}

/* 新闻卡片日期样式 */
.news-card .text-gray-500 {
  font-family: 'Courier New', monospace;
}

/* 适配移动端表单 */
@media (max-width: 767px) {
  form {
    gap: 4px;
  }

  form div {
    margin-bottom: 4px;
  }
}
</style>